// extracted by mini-css-extract-plugin
export default {"main_div":"CountForms_main_div__u8t3A","formHeader":"CountForms_formHeader__SgHPp","main_form_div":"CountForms_main_form_div__-3k2U","sku_div":"CountForms_sku_div__Sfq+2"};